namespace $.$$ {
	$mol_style_define( $shm_dashboard_admin_wordstat, {
		Stats: {
			flexWrap: 'wrap',
			gap: $mol_gap.block,
		},
	} )
}
